
export type ReadAllNotifications200 = {
  /** 읽음 처리된 알림 수 */
  count?: number;
  success?: boolean;
};
